import React from 'react';

import AccountCardConfigurator from './AccountCardConfigurator';
import withModal from '../../../../components/global/modal/withModal';

export const ACCOUNT_CARD_CONFIGURATOR_MODAL =
  'modal/ACCOUNT_CARD_CONFIGURATOR';

const AccountCardConfiguratorModal = props => {
  return <AccountCardConfigurator {...props} />;
};

export default withModal(AccountCardConfiguratorModal, {
  name: ACCOUNT_CARD_CONFIGURATOR_MODAL,
  type: 'full',
  size: 'md',
  overlayClassName: 'account-card-config-modal-overlay',
});
